import React from "react";
import NavBar from "../elements/NavBar";
import Footer from "../elements/Footer";
import ParticlesComponent from "../elements/Particles";


const Contact = () => {
    return (
        <>

        <ParticlesComponent />
        <div>
            <NavBar />
            <Footer />
        </div>
        </>
    );
}

export default Contact;